import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCapability } from '../instances/useInstance';
import { RootState } from '../store/store';

export const useDarkMode = () => {
  const currentUser = useSelector((state: RootState) => state.user.profile);
  // An instance that forces a theme decides the way out, whatever the stored
  // theme says: dark stays, light goes back to light.
  const forcedTheme = useCapability('forcedTheme');

  useEffect(() => {
    document.body.classList.add('theme-dark');

    return () => {
      // Only remove the class if the user's theme is light mode
      const isLightAfter =
        forcedTheme === 'light' ||
        (currentUser?.theme === 'light' && forcedTheme !== 'dark');

      if (isLightAfter) {
        document.body.classList.remove('theme-dark');
      }
    };
  }, [currentUser?.theme, forcedTheme]);
};
